import storage from 'src/utils/storage';

const getAuthString = () => `Bearer ${storage.authToken.get()}`;

export default getAuthString;
